import React, { FunctionComponent, ReactNode, useState } from 'react'
import styled from 'styled-components'

const Outer = styled.div`
  width: 100%;
  &::after {
    content: '';
    display: block;
    height: 0.125rem;
    width: 100vw;
    position: absolute;
    left: 0;
    background-color: var(--border-color);
  }
`

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 3rem 0;
`
const ContentContainer = styled.div`
  margin-bottom: 3rem;
`



type FoldableProps = {
  header: ReactNode
  children?: ReactNode
  color: string
}
export const Foldable: FunctionComponent<FoldableProps> = ({children, header, color}) => {
  const [open, setOpen] = useState(false)
  return <Outer style={{'--border-color': color}}>
    <HeaderContainer onClick={() => setOpen(v => !v)}>
      {header}
    </HeaderContainer>
    <ContentContainer style={{display: open ? 'block' : 'none'}}>
      {children}
    </ContentContainer>
  </Outer>
}